module.exports = __webpack_public_path__ + "static/media/MAIL@3x.f0849768.png";